import React from 'react'
import styled, { css } from 'styled-components'
import { withBox } from 'components/Box'
import { buttonUnstyledStyles } from 'components/Button'
import DropdownItemDescription from '../DropdownItemDescription'
import { NavLink } from 'react-router-dom'
import { truncateStyles } from 'components/Truncate'
import { DropdownItemProps } from './types'

export const dropdownItemStyles = css<DropdownItemProps>(
  ({ theme, intent, disabled }) => css`
    ${buttonUnstyledStyles};
    ${truncateStyles};

    display: block;
    width: 100%;
    min-width: 150px;
    white-space: initial;

    padding: 8px 12px;

    color: ${disabled
      ? theme.colors.foreground.secondary[4]
      : intent === 'negative'
      ? theme.colors.state.negative
      : theme.colors.foreground.secondary[2]};
    font-size: ${theme.fontSizes.smaller};
    font-weight: ${theme.fontWeights.regular};
    line-height: 1.5;
    text-align: left;

    border-radius: ${theme.radii.large};
    cursor: pointer;

    transition: background-color ${theme.transitions.duration[1]}
        ${theme.transitions.timing.easeOut},
      color ${theme.transitions.duration[1]}
        ${theme.transitions.timing.easeOutExponential};

    @media (hover: hover) {
      &:hover,
      &:active,
      &[aria-selected='true']:not([aria-disabled='true']) {
        background: ${theme.colors.background.tertiary[1]};
        color: ${intent === 'negative'
          ? theme.colors.state.negative
          : theme.colors.foreground.secondary[1]};

        ${DropdownItemDescription} {
          color: ${theme.colors.foreground.secondary[2]};
        }
      }
    }

    &[aria-disabled='true'] {
      color: ${theme.colors.foreground.secondary[4]};
      pointer-events: none;
    }

    &.focus,
    &.active,
    &[data-current] {
      background-color: ${theme.colors.primaryTint[10]};
      color: ${theme.colors.primaryTint[100]};

      font-weight: ${theme.fontWeights.medium};

      ${DropdownItemDescription} {
        color: ${theme.colors.foreground.secondary[4]};
      }
    }
  `
)

export const ListItem = styled.li`
  list-style: none;
  padding: 0 8px;
`

export const DropdownItemAnchorStyle = styled.a`
  ${dropdownItemStyles};
`

export const DropdownItemNavLinkStyle = styled(({ ...rest }) => (
  <NavLink {...rest} />
))`
  ${dropdownItemStyles};
`

export const DropdownItemStyle = styled(withBox('button')).attrs(() => ({
  type: 'button',
}))`
  ${dropdownItemStyles};
`
